import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MeasgrowthService } from '../measgrowth.service';
import { ExamsService } from '../exams.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AutotextService } from '../autotext.service';
import { Subject, Subscription } from 'rxjs';
import { FetalechoService } from '../fetalecho.service';
import { LoginService } from '../login.service';
import { PrintService } from '../print.service';

@Component({
    selector: 'app-measurements',
    templateUrl: './measurements.component.html',
    styleUrls: ['./measurements.component.scss'],
    standalone: false
})
export class MeasurementsComponent implements OnInit, AfterViewInit {

  GAlmp: string;
  fetusSub: Subscription;
  mediaSub: Subscription;
  Comment: UntypedFormControl;
  IsWeightAss = false;
  IsFetalEcho = false;
  showComment = false;
  text;
  sub;
  @ViewChild("CommentsExtra") set CommentsExtra(ref: ElementRef) {
    if (!!ref) {
      ref.nativeElement.focus() ;
    }
  }
  @Input('fetus') fetus: number =1;
  

  constructor(public fes:FetalechoService,private measService: MeasgrowthService, public es: ExamsService, public atS: AutotextService, public print:PrintService, public ls:LoginService) {
    this.measService.setGA();
    this.Comment = new UntypedFormControl();

    if(this.es.ExamType === 'Weight Assessment' || this.es.ExamType == 'Tech Exam'){
      this.IsWeightAss = true;
    }
    if(this.es.ExamType === 'Fetal Echo'){
      this.IsFetalEcho = true;
      // this.fes.getFetalEchoData(this.es.examID, 'meas');
      // this.fes.resetMeas();
      // this.fes.getFetalMeasure();
    }
    // this.sub = this.es.examLoaded$.subscribe((data) =>{
    //   this.fes.resetMeas();
    //   this.fes.getFetalMeasure();
    // })
  }


  ngOnInit() {
    this.measService.fetchValues(this.Comment);
    this.fetusSub = this.es.fetusChange$.subscribe(() => {
      this.measService.fetchValues(this.Comment);
      // this.fes.getFetalEchoData(this.es.examID,'meas');
      // this.fes.getFetalMeasure()
    });
    this.es.getSRs();
    if(!this.es.isClosed)
      this.mediaSub =  this.es.mediaArrived$.subscribe((mediatype)=>{
        if(mediatype == 'html')
          this.measService.fetchValues(this.Comment);
      });
  }
  ngAfterViewInit(): void {
    this.Comment.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(data => {
      this.measService.saveMeas("Comments", this.Comment.value);
    });
    this.Comment.valueChanges.subscribe((data) => {
      if(data != null){
        this.showComment= true;
        this.text = data;
      }
      // this.measService.saveMeas("Comments", this.Comment.value);
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.fetusSub.unsubscribe();
    if(this.mediaSub)
      this.mediaSub.unsubscribe();
  }
  onClosed(closed: string){
    if(closed){
      this.showComment = false;
    }
    if(closed =='meas')
      this.measService.fetchValues(this.Comment);
  }


}
